import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import {initReactI18next} from 'react-i18next';
import resources from 'virtual:i18next-loader';

import {fallbackLanguage, supportedLanguages} from './i18nConfig';

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    resources,
    supportedLngs: [...supportedLanguages],
    fallbackLng: fallbackLanguage,
    keySeparator: false,
    debug: process.env.NODE_ENV === 'debug',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
